<template>
  <div class="">
    <van-cell
      title="预约时间"
      title-class="font-color-active"
      icon="location-o"
    />
    <date-card-picker
      v-model="date"
      :disabled="disabledDate"
      :maxDate="maxDate"
    ></date-card-picker>
    <van-cell
      title="医生职称"
      title-class="font-color-active"
      icon="manager-o"
    />
    <div>
      <card-picker v-model="doctorTypeValue" :selectData="doctorTypes" />
    </div>
    <div style="padding:0 0.5rem">
      <van-row>
        <van-col span="12">
          <van-button size="small" @click="closePopup">取消</van-button>
        </van-col>
        <van-col span="12" style="text-align:right;">
          <van-button type="primary" @click="submit" size="small"
            >确认</van-button
          >
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import { Cell, Button, Row, Col } from "vant";
import DateCardPicker from "@/components/DateCardPicker";
import CardPicker from "@/components/CardPicker";

export default {
  name: "DoctorScreen",
  components: {
    DateCardPicker,
    CardPicker,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
  },
  props: {
    disabledDate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      date: [],
      maxDate: "",
      doctorTypeValue: 0,
      doctorTypes: [],
    };
  },
  created() {
    this.maxDate = "";
    this.getDoctorTypes();
  },
  methods: {
    getDoctorTypes() {
      this.$post("Doctor_Types").then(res => {
        res.Data.unshift({
          Id: 0,
          Text: "全部",
        });
        this.doctorTypes = res.Data;
      });
    },
    submit() {
      let date = this.date;
      if (this.date && this.date.length && !this.date[1]) {
        date[1] = this.date[0];
      }
      const arr = {
        date: date,
        value: this.doctorTypeValue,
      };
      this.$emit("submit", arr);
    },
    closePopup() {
      this.date = [];
      this.doctorTypeValue = 0;
      this.$emit("close");
    },
  },

  onSearch() {
    console.log(1);
  },
};
</script>

<style lang="less"></style>
